import { useContext } from 'react';
import AvailabilityAction from '~/constants/availabilityAction';
import CtaType from '~/constants/ctaType';
import {
  UserVehicleContext,
  useVehicleAvailability
} from '~/context/vdp/UserVehicleContext';
import {
  useGetVehicleId,
  useGetVehicleStockNumber
} from '~/context/vdp/VehicleContext';
import useIsAvailabilityDisabled from './useIsAvailabilityDisabled';

export default function useCtaButtonState() {
  const { isLoaded } = useContext(UserVehicleContext).vehicleAvailability;
  const isAvailabilityDisabled = useIsAvailabilityDisabled();
  const stockNumber = useGetVehicleStockNumber();
  const vehicleId = useGetVehicleId();
  const { action } = useVehicleAvailability();

  const isDisabled = !isLoaded || isAvailabilityDisabled;
  const getStarted = action === AvailabilityAction.GetStarted;
  const preOrderNow =
    action === AvailabilityAction.PreOrderNow ||
    action === AvailabilityAction.PreOrderNowDisabled;
  const continuePurchase = action === AvailabilityAction.ContinuePurchase;
  const continueReservation = action === AvailabilityAction.ContinueReservation;
  const notifyMe = action === AvailabilityAction.NotifyMe;

  const type = (() => {
    switch (true) {
      case continuePurchase:
        return CtaType.ContinuePurchase;
      case getStarted:
        return CtaType.GetStarted;
      case continueReservation:
        return CtaType.Reservation;
      case notifyMe:
        return CtaType.NotifyMe;
      case preOrderNow:
        return CtaType.Reservable;
      case !isLoaded:
        return CtaType.Loader;
      default:
        return CtaType.Default;
    }
  })();

  return {
    continuePurchase,
    getStarted,
    isDisabled,
    notifyMe,
    showGetStartedHelp: getStarted || continuePurchase,
    stockNumber,
    type,
    vehicleId,
    wip: preOrderNow
  };
}
